// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    width: 100vw;
    height: 4rem;
    background: rgb(40, 40, 40);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 300;
    font-size: small;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/footer.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".footer {\n    width: 100vw;\n    height: 4rem;\n    background: rgb(40, 40, 40);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 300;\n    font-size: small;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
